<aside class="page-aside" style="min-width:14rem;padding:0 var(--wa-spacing-large) var(--wa-spacing-large) var(--wa-spacing-large);position:sticky;top:var(--wa-spacing-large);">
	<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>Capabilities</div>
	<ul style="display:flex;flex-direction:column;gap:var(--wa-spacing-x-small);list-style:none;margin:var(--wa-spacing-small) 0 0 0;padding:0;">
		<li>
			<a (click)="navigateTo('capabilities')" href="javascript:void(0)" style="cursor:pointer;">Overview</a>
		</li>
		<li>
			<a (click)="navigateTo('capabilities/angular-generation')" href="javascript:void(0)" style="cursor:pointer;">Angular Generation</a>
		</li>
		<li>
			<a (click)="navigateTo('capabilities/rendering')" href="javascript:void(0)" style="cursor:pointer;">Rendering</a>
		</li>
		<li>
			<a (click)="navigateTo('capabilities/event-system')" href="javascript:void(0)" style="cursor:pointer;">Event System</a>
		</li>
		<li>
			<a (click)="navigateTo('capabilities/plugin-model')" href="javascript:void(0)" style="cursor:pointer;">Plugin Model</a>
		</li>
		<li>
			<a (click)="navigateTo('capabilities/real-time-messaging')" href="javascript:void(0)" style="cursor:pointer;">Real-Time Messaging</a>
		</li>
		<li>
			<a (click)="navigateTo('capabilities/spi-extensibility')" href="javascript:void(0)" style="cursor:pointer;">SPI Extensibility</a>
		</li>
	</ul>
</aside>